import React, { FC, useRef, useState, useEffect } from 'react';

import SvgIcon from '~src/shared/SvgIcon';

import DebounceInput from './DebounceInput';
import { SearchWrapper, ResetIcon } from './simpleSearchInput.sc';

export interface SearchInpProps {
  placeholder?: { key: string; value: string };
  onChange: (value: string) => Promise<any>;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  debounceTimeout?: number;
  setFocus?: boolean;
  resetSearch?: boolean;
  initValue?: string;
}

const SimpleSearchInput: FC<SearchInpProps> = props => {
  const [focused, setFocused] = useState(false);
  const input = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (input.current && props.initValue) {
      input.current.value = props.initValue;
    }
  }, []);

  useEffect(() => {
    if (input.current && props.setFocus) {
      // fix to set focus on popover open
      setTimeout(() => input.current!.focus(), 100);
    }
  }, [props.setFocus]);

  useEffect(() => {
    if (props.resetSearch) resetSearch();
  }, [props.resetSearch]);

  const onFocus = () => {
    setFocused(true);
  };

  const onBlur = () => {
    setFocused(false);
  };

  const resetSearch = () => {
    if (input.current) {
      input.current.value = '';
      props.onChange('');
    }
  };

  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => props.onChange(event.target.value);

  const setInputNode = (node: HTMLInputElement | null) => {
    if (node) {
      input.current = node;
    }
  };

  return (
    <SearchWrapper
      $focused={focused}
      $hasValue={!!input.current && !!input.current.value}
      onKeyDown={props.onKeyDown}
    >
      <SvgIcon width={15} name="iconSearchSmall" />
      <DebounceInput
        onBlur={onBlur}
        onFocus={onFocus}
        debounceTimeout={props.debounceTimeout || 500}
        placeholder={props.placeholder}
        onChange={onChangeInput}
        setInputNode={setInputNode}
      />
      <ResetIcon $show={!!input.current && !!input.current.value} onClick={resetSearch}>
        <SvgIcon width={15} name="iconCrossInCircle" />
      </ResetIcon>
    </SearchWrapper>
  );
};

export default SimpleSearchInput;
